/* eslint-disable no-unused-vars */
/* eslint-disable */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeSvg from 'src/assets/close.svg';
import { AxiosResponse } from 'axios';
import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  FullScreenLoading,
  RegularButton,
  AlertAdapter,
  CustomCheckBox,
} from 'pg-ui-library';
import Select from 'react-select';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IAddresses } from 'src/interfaces/personal-info';
import { useActions } from 'src/hooks/useActions';
import { useQuery } from '@tanstack/react-query';
import PersonalInfoService from 'src/services/personal-info.service';
import { CloseIcon, AddressesForm, FormInputWrapper, ActionWrapper, AddressForms, HeadingShow } from './styles';
import { useAddAddress, useUpdateDependent } from '../../../mutations/add-delete-update.mutation';

interface PostalCode {
  ZipCode: string;
  CountryRegionId: string;
  StateId: string;
  CountyId: string;
  CityId: string;
}

const isPrimaryOptions = [
  { key: 'yes', value: 'Yes', label: 'Yes' },
  { key: 'no', value: 'No', label: 'No' },
];

const purposeOptions = [
  { key: 'business', value: 'Business', label: 'Business' },
  { key: 'home', value: 'Home', label: 'Home' },
];

const PersonalAddressForm: React.FC<{ addressUpdate: IAddresses[]; onSuccess: () => void }> = ({
  addressUpdate,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const { getPersonalInfo } = useActions();
  const { data } = useTypedSelector(state => state.personalInfo);
  const [contactId, setContactId] = useState('');
  const addAddAddress = useAddAddress();
  const updateAddress = useUpdateDependent();
  const [isUpdate, setIsUpdate] = useState(true);

  const [postalCodeOptions, setPostalCodeOptions] = useState<{ value: string; label: string }[]>([]);

  const postalCodes = useQuery<AxiosResponse<{ allPostalCodes: PostalCode[] }>>(
    ['/personal-informations/saved-postal-codes'],
    async () => {
      try {
        const result = await PersonalInfoService.getPostalCodes();
        return result;
      } catch (e) {
        const errorMessage = 'Error fetching postal codes: ' + e;
        AlertAdapter(errorMessage, 'error');
        onSuccess();
        getPersonalInfo();
        throw new Error(errorMessage);
      }
    }
  );

  useEffect(() => {
    if (addressUpdate[0]?.id) {
      setContactId(addressUpdate[0]?.id);
    } else {
      setIsUpdate(false);
    }
  }, [addressUpdate]);

  const validationSchema = yup.object({
    postalCode: yup.string().required('Postal Code is required').matches(/^\d+$/, 'Postal Code must be numeric'),
    street: yup.string().required('Full Address is required').min(1, 'Full Address cannot be empty'),
  });

  useEffect(() => {
    if (postalCodes.data) {
      const postalCodeList = postalCodes.data.data.allPostalCodes.map(code => ({
        value: code.ZipCode,
        label: code.ZipCode,
      }));
      setPostalCodeOptions(postalCodeList);
    }
  }, [postalCodes.data]);

  const formik = useFormik({
    initialValues: {
      state: isUpdate ? addressUpdate[0]?.state || '' : '',
      county: isUpdate ? addressUpdate[0]?.county || '' : '',
      description: isUpdate ? addressUpdate[0]?.description || '' : '',
      city: isUpdate ? addressUpdate[0]?.city || '' : '',
      postalCode: isUpdate ? addressUpdate[0]?.zipCode || '' : '',
      country: isUpdate ? addressUpdate[0]?.country || 'USA' : 'USA',
      street: isUpdate ? addressUpdate[0]?.street || '' : '',
      porpouse: isUpdate ? addressUpdate[0]?.porpouse || 'Business' : 'Business',
      isPrimary: isUpdate ? addressUpdate[0]?.isPrimary || 'No' : 'No',
    },
    validationSchema,
    onSubmit: async (values: IAddresses) => {
      try {
        const formData = {
          address: values,
          personnelNumber: data.personalInfo?.employeeNickId ?? '',
        };
        formData.address.personnelNumber = data.personalInfo?.employeeNickId;
        if (isUpdate) {
          formData.address.id = contactId;
          formData.address.location = addressUpdate[0].location;
          await updateAddress.mutateAsync(formData);
          getPersonalInfo();
          onSuccess();
        } else {
          await addAddAddress.mutateAsync(formData);
          getPersonalInfo();
          onSuccess();
        }
      } catch (error) {
        console.error('Error during form Updation', error);
      }
    },
  });

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: '#222247',
      borderRadius: '5px',
      minHeight: '35px',
    }),
  };

  return (
    <>
      {isUpdate ? <HeadingShow>Update Address</HeadingShow> : <HeadingShow>Add New Address</HeadingShow>}
      {(addAddAddress.isLoading || updateAddress.isLoading) && <FullScreenLoading />}
      <AddressForms>
        <AddressesForm onSubmit={formik.handleSubmit} style={{ padding: '20px 7% 20px 20px' }}>
          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)', marginLeft: '5px' }}>
            <CommonInput
              id="street"
              name="street"
              label="Street"
              placeholder="Street"
              value={formik.values.street}
              onChange={event => formik.setFieldValue('street', event.target.value)}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.street as string} visible={!!formik.errors.street} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <label htmlFor="PostalCode" style={{ display: 'block', fontWeight: '400' }}>
              Postal Code
            </label>
            {postalCodes.isLoading ? (
              <FullScreenLoading />
            ) : postalCodes.error ? (
              <p>Error fetching postal codes</p>
            ) : (
              <div style={{ marginTop: '5px' }}>
                <Select
                  id="PostalCode"
                  name="PostalCode"
                  label="Postal Code"
                  options={postalCodeOptions}
                  value={postalCodeOptions.find(option => option.value === formik.values.postalCode)}
                  onChange={(selectedOption: { value: string; label: string } | null) => {
                    const selectedCode = postalCodes.data?.data.allPostalCodes.find(
                      code => code.ZipCode === selectedOption?.value
                    );
                    if (selectedCode) {
                      formik.setValues({
                        ...formik.values,
                        state: selectedCode.StateId,
                        city: selectedCode.CityId,
                        county: selectedCode.CountyId,
                      });
                    }
                    formik.setFieldValue('postalCode', selectedOption?.value || '');
                  }}
                  getOptionLabel={(option: { value: string; label: string }) => option.label}
                  getOptionValue={(option: { value: string; label: string }) => option.value}
                  placeholder="Select Zip Code"
                  isClearable
                  styles={customStyles}
                />
              </div>
            )}
            <FormErrorWrap errorMessage={formik.errors.postalCode as string} visible={!!formik.errors.postalCode} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <CommonInput
              id="state"
              name="state"
              label="State"
              placeholder="State"
              value={formik.values.state}
              onChange={event => formik.setFieldValue('state', event.target.value)}
              disabled
              style={{ width: '100%' }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <CommonInput
              id="county"
              name="county"
              label="County"
              placeholder="County"
              value={formik.values.county}
              onChange={event => formik.setFieldValue('County', event.target.value)}
              disabled
              style={{ width: '100%' }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <CommonInput
              id="city"
              name="city"
              label="City"
              placeholder="City"
              value={formik.values.city}
              onChange={event => formik.setFieldValue('city', event.target.value)}
              disabled
              style={{ width: '100%' }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <CommonInput
              id="country"
              name="country"
              label="Country"
              placeholder="Country"
              value={formik.values.country}
              disabled
              onChange={event => formik.setFieldValue('country', event.target.value)}
              style={{ width: '100%' }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)', marginLeft: '5px' }}>
            <CommonDropdown
              label="Is Primary"
              id="isPrimary"
              name="isPrimary"
              options={isPrimaryOptions}
              value={formik.values.isPrimary}
              setValue={(value: string) => formik.setFieldValue('isPrimary', value)}
              selectStyle={{
                width: '100%',
                maxWidth: '100%',
                marginTop: '8px',
                height: 'auto',
              }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(50% - 20px)' }}>
            <CommonDropdown
              label="Purpose"
              id="porpouse"
              name="porpouse"
              options={purposeOptions}
              value={formik.values.porpouse}
              setValue={(value: string) => formik.setFieldValue('porpouse', value)}
              selectStyle={{
                width: '100%',
                maxWidth: '100%',
                marginTop: '8px',
                height: 'auto',
              }}
            />
          </FormInputWrapper>
        </AddressesForm>
        <ActionWrapper>
          {isUpdate ? (
            <RegularButton type="button" onClick={() => formik.handleSubmit()}>
              {t('global.form.update')}
            </RegularButton>
          ) : (
            <RegularButton
              type="button"
              onClick={() => formik.handleSubmit()}
              disabled={!formik.isValid || addAddAddress.isLoading}
            >
              {t('global.form.saveSubmit')}
            </RegularButton>
          )}
        </ActionWrapper>
      </AddressForms>
    </>
  );
};

export const PersonalAddressModal: React.FC<{
  updateAddress: IAddresses[];
  isOpen: boolean;
  setIsOpen: Function;
}> = ({ updateAddress, isOpen, setIsOpen }) => {
  const modalRef = useRef(null);

  const handleModalClose = () => {
    setIsOpen(false);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '10px',
          background: '#f3f4f8',
          margin: 'auto',
          maxWidth: '800px',
          minWidth: '700px',
          height: '500px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
      onRequestClose={handleModalClose}
      contentRef={(node: any) => (modalRef.current = node)}
    >
      <CloseIcon src={closeSvg} onClick={handleModalClose} />
      <PersonalAddressForm addressUpdate={updateAddress} onSuccess={handleModalClose} />
    </ReactModal>
  );
};
